module.exports = __webpack_public_path__ + "media/images/svg/vimeo-f6101728656fe3631b50212589587271.svg";